var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge"},[_c('transition',{attrs:{"appear":"","name":"badge-update"}},[(_vm.showBadge)?_c('div',{key:_vm.valueGetter,staticClass:"badge__item"},[_c('span',[_vm._v(_vm._s(_vm.valueGetter))])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }